import store from '@/state/store'

export default [{
    path: '/',
    name: 'home',
    component: () => import('../views/pages/chat/index')
},
{
    path: '/login',
    name: 'login',
    component: () => import('../views/pages/account/login'),
    meta: {
        beforeResolve(routeTo, routeFrom, next) {
            const time = new Date();
            const hour = time.getHours()
            if ((hour >= 0 && hour < 10) || hour >18) {
          //  if(!hour) {  
            next({
                    name: 'offline'
                })
            } else {


                // If the user is already logged in
                if (store.state.authfack.status.loggeduser) {
                    // Redirect to the home page instead
                    next({
                        name: 'home'
                    })
                } else {
                    // Continue to the login page
                    next()
                }
            }
        },
    },
},
{
    path: '/chat',
    name: 'chat',
    component: () => import('../views/pages/chat/index'),
    meta: {
        beforeResolve(routeTo, routeFrom, next) {

            // If the user is already logged in
            if (!store.state.authfack.status.loggeduser) {
                // Redirect to the home page instead
                next({
                    path: '/'
                })
            } else {
                // Continue to the login page
                next()
            }
        },
    }

},
{
    path: '/logout',
    name: 'logout',
    meta: {
        beforeResolve(routeTo, routeFrom, next) {

            store.dispatch('authfack/logout')
            next({
                path: '/'
            })


        },
    },
},
{
    path: '/offline',
    name: 'offline',
    component: () => import('../views/pages/account/offline'),
    meta: {
        beforeResolve(routeTo, routeFrom, next) {
            const time = new Date();
            const hour = time.getHours()
            if ((hour >= 0 && hour < 10) || (hour >= 20)) {
                next()
            } else {
            // If the user is already logged in
            if (store.state.authfack.status.loggeduser) {
                // Redirect to the home page instead
                next({
                    path: '/chat'
                })
            } else {
                // Continue to the login page
                next({
                    path: '/login'

                })
            }}
        },
    }

},
{
    path: '*',
    redirect: '/chat',
},
]